// src/postsSlice.js
import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getBranchesList = createAsyncThunk('branches/list', async () => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/branch/',
      method: 'GET',
    });
    //console.log('GET',response)
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});
export const branchIdCheck = createAsyncThunk(
  'branchIdCheck/fetch',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/branch/idCheck/${id}`,
        method: 'GET',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const postBranch = createAsyncThunk('branches/post', async (Data) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: '/branch/',
      method: 'POST',
      data: Data,
    });
    //console.log('POST',response)
    return response?.status;
  } catch (error) {
    console.log(error);
  }
});

export const updateBranch = createAsyncThunk(
  'branches/update',
  async (Data) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/branch/',
        method: 'PUT',
        data: Data,
      });
      return response?.status;
    } catch (error) {
      console.log(error);
    }
  },
);

export const deleteBranch = createAsyncThunk('branches/delete', async (id) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/branch/${id}`,
      method: 'DELETE',
    });
    return response?.status;
  } catch (error) {
    console.log(error);
  }
});
const branchSlice = createSlice({
  name: 'branches',
  initialState: {
    branchesList: [],
    status: '',
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBranchesList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBranchesList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.branchesList = action.payload;
      })
      .addCase(getBranchesList.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error.message;
      });
  },
});
export default branchSlice.reducer;
